module.exports = __webpack_public_path__ + "static/media/piyush-goyal-original.9432a88f.png";